<template>
  <DraggableItems
    :left-heading="leftHeading"
    :right-heading="rightHeading"
    :left-fields.sync="unusedFields"
    :right-fields.sync="selectedFields"
  />
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import DraggableItems from '@/components/common/DraggableFields/DraggableItems.vue'

const components = {
  DraggableItems,
}

const props = {
  leftHeading: {
    type: String,
    default: null,
  },
  rightHeading: {
    type: String,
    default: null,
  },
  sourceFields: {
    // Full fields
    type: Array as PropType<{ column: string, name: string }[]>,
    default: () => [],
  },
  selectedColumns: {
    // Column names only
    type: Array as PropType<string[]>,
    default: () => [],
  },
}

@Component({ components })
export default class DraggableFields extends Vue.extend({ props }) {
  get unusedFields () {
    return this.sourceFields.filter((item) => {
      return !this.selectedColumns.includes(item.column)
    })
  }

  set unusedFields (_) {}

  get selectedFields () {
    return this.selectedColumns
      .map((column) => {
        return this.sourceFields.find((item) => {
          return item.column === column
        })
      })
      .filter(f => f) // only return fields that exist
  }

  set selectedFields (newArray) {
    const columns = newArray
      .map((item) => {
      // Full fields are added to the array by draggable whereas only columns
      // are stored in the config
        return item!.column ? item!.column : item
      })
    this.$emit('update:selectedColumns', columns)
  }
}

</script>

<style scoped>

.placeholder {
  font-style: italic;
}

.list-group-item {
  cursor: move;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 9px;
  padding-right: 9px;
}

</style>
